/*
 * @Author: wq
 * @Date: 2020-07-14 10:01:56
 */
import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import store from "./vuex/store";
import router from "./router";
import "@/assets/css/normalize.css"; // 初始化样式
import "element-ui/lib/theme-chalk/index.css";
// import ElementUI from "element-ui"; // 全局引入
// import 'lib-flexible/flexible' // rem适配
import { imgUrlBase, api, debug_mode } from "./assets/api/http"; // 响应拦截、接口配置
import { fetch, post } from "./assets/api/request"; // 封装get、post请求
import {
  Popover,
  Container,
  Header,
  Row,
  Col,
  Main,
  Footer,
  Icon,
  Select,
  Option,
  Input,
  Form,
  FormItem,
  Cascader,
  CheckboxGroup,
  Checkbox,
  Button,
  Table,
  TableColumn,
  Pagination,
  DatePicker,
  Carousel,
  CarouselItem,
  Collapse,
  CollapseItem,
  Tag,
  Message,
  MessageBox,
  Dialog,
  Upload,
  Loading
} from "element-ui";
// Vue.use(ElementUI); // 全局引入
Vue.use(Popover);
Vue.use(Container);
Vue.use(Header);
Vue.use(Row);
Vue.use(Col);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Icon);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Cascader);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(DatePicker);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Tag);
Vue.use(Dialog);
Vue.use(Upload);
Vue.use(Loading);
Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox.alert;

// 图片预览插件
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: "data-source"
  }
});

const { log, groupCollapsed } = console;
console.log = (...args) => {
  debug_mode && log.apply(console, args);
};
console.groupCollapsed = (...args) => {
  debug_mode && groupCollapsed.apply(console, args);
};

Object.assign(Vue.prototype, {
  $post: post,
  $get: fetch,
  $api: api,
  $imgUrlBase: imgUrlBase
});

// router.beforeEach((to, from, next) => {
//   // chrome
//   document.body.scrollTop = 0;
//   // firefox
//   document.documentElement.scrollTop = 0;
//   // safari
//   window.pageYOffset = 0;
//   next();
// });

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  render: h => h(App),
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js